export default "__VITE_ASSET__BgPSInvR__"